<h1 class="typography-title-large">
  {{ data.title }}
</h1>
<p class="typography-body-large" [innerHtml]="data.message"></p>
<div class="actions-section">
  <app-button
    [label]="data['okBtnText'] || 'تایید'"
    variant="secondary-contained"
    [fullWidth]="true"
    (btnClick)="onAccept()"
    cdkFocusInitial
  />
  <app-button
    [label]="data['cancelBtnText'] || 'انصراف'"
    variant="outlined"
    [fullWidth]="true"
    (btnClick)="onNoClick()"
  />
</div>
